export const ADA_CHATBOT_CONTAINER = "ada-chatbot-container";
